import React, { useState, useEffect } from 'react'
import { SvgIcon } from '../SvgIcon/SvgIcon'
import classNames from 'classnames'

const cx = classNames.bind(require('./styles.scss'))

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false)

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true)
        } else {
            setIsVisible(false)
        }
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility)

        return () => {
            window.removeEventListener('scroll', toggleVisibility)
        }
    }, [])

    return (
        <button className={cx(`scroll-to-top ${isVisible ? 'visible' : ''}`)} onClick={scrollToTop}>
           <SvgIcon src='/icon/arrow-circle.svg'/>
        </button>
    )
}

export default ScrollToTopButton
